import { render, staticRenderFns } from "./PertanyaanJawaban.vue?vue&type=template&id=12246e5b"
import script from "./PertanyaanJawaban.vue?vue&type=script&lang=js"
export * from "./PertanyaanJawaban.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports